import React, { useContext, useEffect, useState } from "react";
import File from "../../assets/files.svg";
import Settings from "../../assets/settings.svg";
import User from "../../assets/user.svg";
import OpenAI from "../../assets/openai.png";
import "./sideBar.css";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../store/AuthContext";
import AIimage from "../../assets/image002.png";
import NoteImage from "../../assets/sticky-notes.png";
import { ThemeContext } from "../../store/ThemeContext";

const SideBar = () => {
  const [tab, setTab] = useState(null);
  const [minimize, setMinimize] = useState(false);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const { theme, toggleTheme, themeMode } = useContext(ThemeContext);

  useEffect(() => {
    setMinimize(false);
    if (window.location.pathname === "/dictate") setTab(6);
    else if (window.location.pathname === "/prompt") setTab(5);
    else if (window.location.pathname === "/upload") setTab(4);
    else if (window.location.pathname === "/organizations") setTab(3);
    else if (window.location.pathname === "/settings") setTab(1);
    else if (window.location.pathname === "/users") setTab(2);
    else if (window.location.pathname === "/InteliDoc-GPT") {
      setTab(7);
      setMinimize(true);
    } else if (window.location.pathname === "/") setTab(0);
    else {
    }
    // eslint-disable-next-line
  }, [window.location]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        // width: "80px",
        background: theme?.sideBarBg,
      }}
    >
      <div
        className={tab === 0 ? "sideBarBox selectedBox" : "sideBarBox"}
        style={{ borderColor: theme.hightlightColor }}
        onClick={() => {
          navigate("/");
        }}
      >
        <img src={File} alt="FileImg" />
        {!minimize ? (
          <div className="sideBarBoxTitle">Transcriptions</div>
        ) : null}
      </div>

      <div
        className={tab === 7 ? "sideBarBox selectedBox" : "sideBarBox"}
        style={{ borderColor: theme.hightlightColor }}
        onClick={() => {
          navigate("/InteliDoc-GPT");
        }}
      >
        <img
          src={AIimage}
          style={{ mixBlendMode: "color-dodge" }}
          alt="BastonGPT Logo"
        />
        {!minimize ? (
          <div className="sideBarBoxTitle">InteliDoc-GPT</div>
        ) : null}
      </div>

      <div
        className={tab === 5 ? "sideBarBox selectedBox" : "sideBarBox"}
        style={{ borderColor: theme.hightlightColor }}
        onClick={() => {
          navigate("/prompt");
        }}
      >
        <img src={NoteImage} alt="FileImg" />
        {!minimize ? <div className="sideBarBoxTitle">Prompt</div> : null}
      </div>

      <div
        className={tab === 4 ? "sideBarBox selectedBox" : "sideBarBox"}
        style={{ borderColor: theme.hightlightColor }}
        onClick={() => {
          navigate("/upload");
        }}
      >
        <ion-icon
          name="cloud-upload-outline"
          style={{ color: "white", fontSize: 20 }}
        ></ion-icon>

        {!minimize ? <div className="sideBarBoxTitle">Upload</div> : null}
      </div>

      <div
        className={tab === 6 ? "sideBarBox selectedBox" : "sideBarBox"}
        style={{ borderColor: theme.hightlightColor }}
        onClick={() => {
          navigate("/dictate");
        }}
      >
        <ion-icon
          name="mic-outline"
          style={{ color: "white", fontSize: 20 }}
        ></ion-icon>

        {!minimize ? <div className="sideBarBoxTitle">Dictate</div> : null}
      </div>

      {(authCtx.isAdmin || authCtx.isSuperAdmin) === true && (
        <div
          className={tab === 2 ? "sideBarBox selectedBox" : "sideBarBox"}
          style={{ borderColor: theme.hightlightColor }}
          onClick={() => {
            navigate("/users");
          }}
        >
          <img src={User} alt="UserImg" />

          {!minimize ? <div className="sideBarBoxTitle">Users</div> : null}
        </div>
      )}

      {authCtx.isAdmin === true && (
        <div
          className={tab === 1 ? "sideBarBox selectedBox" : "sideBarBox"}
          style={{ borderColor: theme.hightlightColor }}
          onClick={() => {
            navigate("/settings");
          }}
        >
          <img src={Settings} alt="SettingsImg" />
          {!minimize ? <div className="sideBarBoxTitle">Settings</div> : null}
        </div>
      )}

      {authCtx.isSuperAdmin === true && (
        <div
          className={tab === 3 ? "sideBarBox selectedBox" : "sideBarBox"}
          style={{ borderColor: theme.hightlightColor }}
          onClick={() => {
            navigate("/organizations");
          }}
        >
          <ion-icon
            name="business-outline"
            style={{ color: "white", fontSize: 20 }}
          ></ion-icon>

          {!minimize ? (
            <div className="sideBarBoxTitle">Organizations</div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default SideBar;
